<template>
  <layout>
    <div class="w-full sm:w-1/2 mx-auto mb-0 mt-4 px-4 py-2 text-left">

      <div class="max-w-lg mb-5 pb-0">
        <p class="text-lg mb-2 sm:text-xl font-extralight flex items-center">
          <Link :href="route('control-panel.workshops.index')"><svg xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg></Link>
          {{ headline }} <testmode-badge :session="session" class="ml-3"></testmode-badge>
        </p>

        <progress-tabs :active-index="3" :session="session" :disable-more="false"
          @clicked="handleTabClick"></progress-tabs>

      </div>


      <!-- <p class="mt-0 mb-2 ml-1 text-lg sm:text-xl font-extralight">
        Bitte User auswählen
      </p> -->


      <!-- author edit view: start-->
      <div v-if="isAuthor">
        <fieldset class="mb-6">
          <!-- Checked: "z-10 border-indigo-200 bg-indigo-50", Not Checked: "border-gray-200" -->


          <p v-if="form.users.length" class="mt-0 mb-2 ml-1 text-sm font-extralight">
            Autor
          </p>


          <div v-if="session.author" class="space-y-2 flex flex-col max-w-lg mb-8">
            <!-- current user: start -->
            <div
              class="rounded-tl-md rounded-md flex border focus:outline-none p-2 bg-white border-gray-200 opacity-100">
              <label :id="`cy_current_user`" class="flex p-1 items-center grow">
                <input type="checkbox" :checked="true" :disabled="true"
                  class="mt-0.5 h-4 w-4 shrink-0 text-markencode-blue border-gray-300 focus:ring-markencode-blue opacity-50" />
                <span class="ml-3 flex flex-col w-full">
                  <span class="block text-sm">{{ session.author?.name }}</span>
                </span>
              </label>
            </div>
            <!-- current user: end -->
          </div>



          <p v-if="form.users.length" class="mt-0 mb-2 ml-1 text-sm font-extralight">
            Weitere User auswählen (optional)
          </p>

          <p v-if="!form.users.length" class="mt-0 mb-2 ml-1 text-sm font-extralight">
            Es liegen keine weiteren Usern vor.
          </p>

          <div class="space-y-2 flex flex-col max-w-lg">
            <!-- users: start -->
            <div v-for="(user, idx) in form.users" :key="idx"
              class="rounded-tl-md rounded-md flex cursor-pointer border focus:outline-none p-2 bg-white border-gray-200"
              :class="user.checked ? 'opacity-100' : 'opacity-50'">
              <label :id="`cy_user_${user.id}`" class="flex p-1 items-center grow cursor-pointer">
                <input type="checkbox" :checked="user.checked" @change="toggleUser(user)"
                  class="mt-0.5 h-4 w-4 shrink-0 cursor-pointer text-markencode-blue border-gray-300 focus:ring-markencode-blue" />
                <span class="ml-3 flex flex-col w-full">
                  <!-- Checked: "text-indigo-700", Not Checked: "text-gray-500" -->

                  <!-- <span v-if="phase.question?.brandname" class="block text-sm" v-html="placeholderWrapper(phase, idx)"></span> -->



                  <span class="block text-sm">{{ user.name }}</span>

                  <span v-if="user.note" class="block text-sm sm:inline">{{
                    user.note
                    }}</span>


                </span>
              </label>
            </div>
            <!-- users: end -->
          </div>
        </fieldset>


        <div class="max-w-lg w-full flex items-end justify-end border-t border-gray-300 pt-4">
          <button type="submit" @click="submit"
            class="inline-flex justify-center bg-brandpreneurship-dark-gray w-full sm:w-min rounded-md border border-transparent px-4 py-2 sm:my-2 sm:px-2 sm:py-2 text-base leading-6 font-medium text-white shadow-sm transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50"
            :class="disabled ? 'opacity-50 cursor-default' : 'hover:bg-black focus:outline-none focus:border-black opacity-100 cursor-pointer'">
            WEITER
          </button>
        </div>

      </div>

      <!-- author edit view: end -->


      <!-- guest view: start-->
      <div v-if="!isAuthor">
        <fieldset class="mb-6">
          <p v-if="form.users.length" class="mt-0 mb-2 ml-1 text-sm font-extralight">
            Autor
          </p>
          
          <div v-if="session.author" class="space-y-2 flex flex-col max-w-lg mb-8">
            <!-- current user: start -->
            <div
              class="rounded-tl-md rounded-md flex border focus:outline-none p-2 bg-white border-gray-200 opacity-100">
              <label :id="`cy_current_user`" class="flex p-1 items-center grow">
                <input type="checkbox" :checked="true" :disabled="true"
                  class="mt-0.5 h-4 w-4 shrink-0 text-markencode-blue border-gray-300 focus:ring-markencode-blue opacity-50" />
                <span class="ml-3 flex flex-col w-full">
                  <span class="block text-sm">{{ session.author?.name }}</span>
                </span>
              </label>
            </div>
            <!-- current user: end -->
          </div>



          <p v-if="form.users.length" class="mt-0 mb-2 ml-1 text-sm font-extralight">
            Weitere User
          </p>

          <!-- <p v-if="!form.users.length" class="mt-0 mb-2 ml-1 text-sm font-extralight">
            Es liegen keine weiteren Usern vor.
          </p> -->

          <div class="space-y-2 flex flex-col max-w-lg">
            <!-- users: start -->
            <div v-for="(user, idx) in form.users" :key="idx"
              class="rounded-tl-md rounded-md flex  border focus:outline-none p-2 bg-white border-gray-200"
              :class="user.checked ? 'opacity-100' : 'opacity-50'">
              <label :id="`cy_user_${user.id}`" class="flex p-1 items-center grow ">
                <input type="checkbox" :checked="user.checked" @change="toggleUser(user)" :disabled="true"
                  class="mt-0.5 h-4 w-4 shrink-0  text-markencode-blue border-gray-300 focus:ring-markencode-blue opacity-50" />
                <span class="ml-3 flex flex-col w-full">
                  
                  <span class="block text-sm">{{ user.name }}</span>

                  <span v-if="user.note" class="block text-sm sm:inline">{{
                    user.note
                    }}</span>


                </span>
              </label>
            </div>
            <!-- users: end -->
          </div>
        </fieldset>


        <div class="max-w-lg w-full flex items-end justify-end border-t border-gray-300 pt-4">
          <button type="submit" @click="submit"
            class="inline-flex justify-center bg-brandpreneurship-dark-gray w-full sm:w-min rounded-md border border-transparent px-4 py-2 sm:my-2 sm:px-2 sm:py-2 text-base leading-6 font-medium text-white shadow-sm transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50"
            :class="disabled ? 'opacity-50 cursor-default' : 'hover:bg-black focus:outline-none focus:border-black opacity-100 cursor-pointer'">
            WEITER
          </button>
        </div>

      </div>
       <!-- guest view: end-->


    </div>


  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import HorizontalDivider from '@/Shared/HorizontalDivider';
import ProgressTabs from '@/Pages/ControlPanel/Workshops/Shared/ProgressTabs';
import TestmodeBadge from '@/Pages/ControlPanel/Shared/TestmodeBadge';

export default {
  components: {
    Layout,
    HorizontalDivider,
    ProgressTabs,
    TestmodeBadge,
  },

  props: ['session', 'translations', 'users'],

  data() {
    return {
      form: this.$inertia.form({
        users: this.users,
      }),
    };
  },


  methods: {
    toggleUser(selectedUser) {
      this.form.users = this.form.users.map((user) => {
        if (user.id == selectedUser.id) {
          user.checked = !user.checked;
        }

        return user;
      });
    },

    handleTabClick(tab) {
      this.submit(tab);
    },

    submit(tab) {
      this.form.post(
        this.route('control-panel.workshops.team.store', {
          sessionUuid: this.session.uuid,
          tab: tab,
        }),
        {}
      );
    },
  },

  computed: {
    isAuthor() {
      return this.session.author_id === this.$page.props.auth.user.id;
    },

    disabled() {
      return false;
    },

    headline() {
      if (this.session.session_type == 'workshop') {
        return `Workshop ${this.session.project_name || ''}`;
      }

      if (this.session.session_type == 'diy_workshop') {
        return `Umfrage ${this.session.project_name || ''}`;
      }

      return 'Workshops &amp; Umfragen';
    },
  },
};
</script>